import React, { useState, useEffect } from "react";
import classes from "./AddProducts.module.css";
import Swal from "sweetalert2";
import api from "../../Components/API/Api";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useNavigate, useLocation } from "react-router-dom";

const AddMember = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isEdit = location.state?.isEdit || false;
  const editMember = location.state?.member || null;

  // 1. Form state mapped perfectly to your API's expected keys
  const [formData, setFormData] = useState({
    member_number: editMember?.member_number || "",
    title: editMember?.title || "",
    first_name: editMember?.first_name || "",
    other_name: editMember?.other_name || "",
    last_name: editMember?.last_name || "",
    email: editMember?.email || "",
    phone_number: editMember?.phone_number || "",
    dob: editMember?.dob || "",
    gender: editMember?.gender || "",
    marital_status: editMember?.marital_status || "",
    nin: editMember?.nin || "",
    bvn: editMember?.bvn || "",
    address: editMember?.address || "",

    // Employment Info
    employer_name: editMember?.employer_name || "",
    staff_id: editMember?.staff_id || "",
    department: editMember?.department || "",
    monthly_salary: editMember?.monthly_salary || "",

    // Next of Kin
    next_of_kin_name: editMember?.next_of_kin_name || "",
    next_of_kin_relationship: editMember?.next_of_kin_relationship || "",
    next_of_kin_phone: editMember?.next_of_kin_phone || "",
    next_of_kin_address: editMember?.next_of_kin_address || "",

    // Guarantor 
    guarantor_name: editMember?.guarantor_name || "",
    guarantor_phone: editMember?.guarantor_phone || "",
    membership_no: editMember?.membership_no || "",

    // Savings Configuration
    monthly_contribution: editMember?.monthly_contribution || "",
    savings_type: editMember?.savings_type || "",
    registration_date: editMember?.registration_date || "",
  });

  const [photoPreview, setPhotoPreview] = useState(editMember?.passport_photograph || null);
  const [passportPhoto, setPassportPhoto] = useState(null);
  const [saving, setSaving] = useState(false);
  const [roleLoading, setRoleLoading] = useState(false);
  const [roles, setRoles] = useState([]);

  // 2. Controlled Inputs Handler
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePassportChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      Swal.fire({ icon: "warning", title: "File too large", text: "Maximum allowed size is 5MB" });
      return;
    }

    setPassportPhoto(file);
    setPhotoPreview(URL.createObjectURL(file));
  };

  const handleRemovePassport = () => {
    setPassportPhoto(null);
    setPhotoPreview(null);
    const input = document.getElementById("passportInput");
    if (input) input.value = "";
  };

  const handleReset = () => {
    setFormData({
      member_number: "", title: "", first_name: "", other_name: "", last_name: "",
      email: "", phone_number: "", dob: "", gender: "", marital_status: "", nin: "", bvn: "", address: "",
      employer_name: "", staff_id: "", department: "", monthly_salary: "",
      next_of_kin_name: "", next_of_kin_relationship: "", next_of_kin_phone: "", next_of_kin_address: "",
      guarantor_name: "", guarantor_phone: "", membership_no: "",
      monthly_contribution: "", savings_type: "", registration_date: ""
    });
    handleRemovePassport();
  };

  // 3. Validation matching your API validation requirements
  const validateForm = () => {
    const requiredFields = [
      "member_number",
      "first_name",
      "last_name",
      "email",
      "phone_number"
    ];
    return requiredFields.filter((key) => !String(formData[key] || "").trim());
  };

  // 4. API Submit Handling
  const handleSubmit = async (e) => {
    e.preventDefault();

    const missing = validateForm();
    if (missing.length) {
      return Swal.fire({
        icon: "error",
        title: "Missing required fields",
        text: `Please provide values for: ${missing.join(", ").replace(/_/g, " ")}`,
        confirmButtonColor: "#0a7d3b",
      });
    }

    setSaving(true);
    try {
      const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");

      const fd = new FormData();
      fd.append("company_id", String(companyId));

      Object.keys(formData).forEach((key) => {
        fd.append(key, formData[key]);
      });

      if (passportPhoto) {
        fd.append("passport_photograph", passportPhoto);
      }

      let res;
      if (isEdit) {
        fd.append("id", editMember?.id);
        res = await api.post(`/v1/update_member`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        res = await api.post(`/v1/member/add`, fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      const isSuccess = res?.data?.status === true || res?.data?.success === true;
      if (isSuccess) {
        await Swal.fire({
          icon: "success",
          title: isEdit ? "Updated!" : "Saved!",
          text: res?.data?.message || "Member records modified successfully.",
          confirmButtonColor: "#0a7d3b",
        });
        navigate(-1);
      } else {
        throw new Error(res?.data?.message || "Server rejected registration.");
      }
    } catch (error) {
     let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        // toast.error(errorMessage)
        console.log(errorMessage);
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: errorMessage,
        });
      }
    } finally {
      setSaving(false);
    }
  };

  const fetRoles = async () => {
    setRoleLoading(true);
    try {
      const response = await api.get(`/v1/savings_product`);
      const data = response.data?.data;
      setRoles(data);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.error(errorStatus);
      setRoles([]);
    } finally {
      setRoleLoading(false);
    }
  };

  useEffect(() => {
    fetRoles();
  }, []);

  return (
    <>
      <HeaderNav />
      <div className={classes.totalContainer}>
        <div className={classes.bredcrmb}>
          <header className={classes.Header}>
            <h2 className={classes.Title}>{isEdit ? "Edit Member" : "Add New Member"}</h2>
            <h1 className={classes.Titles}>
              {isEdit ? "Update profile details." : "Register new member."}
            </h1>
          </header>
        </div>

        <div className={classes.container}>
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className={classes.card}>
              {/* PERSONAL INFORMATION */}
              <h4 className={classes.sectionTitle}>Personal Information</h4>

              {/* Passport Photograph */}
              <div className={classes.field}>
                <label>Passport Photograph</label>
                <div className={classes.logoDrop}>
                  <div className={classes.avatar}>
                    {photoPreview ? (
                      <img src={photoPreview} alt="passport preview" />
                    ) : (
                      <svg width="40" height="40" viewBox="0 0 24 24">
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zM12 14c-4.42 0-8 1.79-8 4v2h16v-2c0-2.21-3.58-4-8-4z" fill="#cbd5e1" />
                      </svg>
                    )}
                  </div>

                  <div className={classes.uploadControls}>
                    <div className={`${classes.small} ${classes.muted}`}>PNG, JPG up to 5MB</div>
                    <div className={classes.uploadButtonGroup}>
                      <label className={`${classes.btn} ${classes.btnGhost}`} htmlFor="passportInput">
                        Choose file
                      </label>
                      <button type="button" className={classes.btn} onClick={handleRemovePassport}>
                        Remove
                      </button>
                    </div>
                    <input id="passportInput" type="file" accept="image/*" className={classes.hidden} onChange={handlePassportChange} />
                  </div>
                </div>
              </div>

              <div className={classes.grid}>
                <div className={classes.inputGroup}>
                  <label>Membership No <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" name="member_number" value={formData.member_number} onChange={handleChange} />
                </div>
                <div className={classes.inputGroup}>
                  <label>Title <span style={{ color: 'red' }}>*</span></label>
                  <select name="title" value={formData.title} onChange={handleChange}>
                    <option value="">Select Title</option>
                    <option>Mr</option>
                    <option>Mrs</option>
                    <option>Miss</option>
                    <option>Dr</option>
                  </select>
                </div>
                <div className={classes.inputGroup}>
                  <label>First Name <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" name="first_name" value={formData.first_name} onChange={handleChange} />
                </div>
              </div>

              <div className={classes.grid}>
                <div className={classes.inputGroup}>
                  <label>Middle Name</label>
                  <input type="text" name="other_name" value={formData.other_name} onChange={handleChange} />
                </div>
                <div className={classes.inputGroup}>
                  <label>Last Name <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" name="last_name" value={formData.last_name} onChange={handleChange} />
                </div>
                <div className={classes.inputGroup}>
                  <label>Email Address <span style={{ color: 'red' }}>*</span></label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} />
                </div>
              </div>

              <div className={classes.grid}>
                <div className={classes.inputGroup}>
                  <label>Phone Number <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" name="phone_number" value={formData.phone_number} onChange={handleChange} />
                </div>
                <div className={classes.inputGroup}>
                  <label>Date of Birth</label>
                  <input type="date" name="dob" value={formData.dob} onChange={handleChange} />
                </div>
                <div className={classes.inputGroup}>
                  <label>Gender</label>
                  <select name="gender" value={formData.gender} onChange={handleChange}>
                    <option value="">Select Gender</option>
                    <option>Male</option>
                    <option>Female</option>
                  </select>
                </div>
              </div>

              <div className={classes.grid}>
                <div className={classes.inputGroup}>
                  <label>Marital Status</label>
                  <select name="marital_status" value={formData.marital_status} onChange={handleChange}>
                    <option value="">Select Status</option>
                    <option>Single</option>
                    <option>Married</option>
                    <option>Divorced</option>
                  </select>
                </div>
                <div className={classes.inputGroup}>
                  <label>NIN <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" name="nin" value={formData.nin} onChange={handleChange} maxLength={11} />
                </div>
                <div className={classes.inputGroup}>
                  <label>BVN <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" name="bvn" value={formData.bvn} onChange={handleChange} />
                </div>
              </div>

              <div className={classes.inputGroup}>
                <label>Residential Address <span style={{ color: 'red' }}>*</span></label>
                <textarea rows="3" name="address" value={formData.address} onChange={handleChange}></textarea>
              </div>

              {/* EMPLOYMENT INFORMATION */}
              <h4 className={classes.sectionTitle}>Employment Information</h4>
              <div className={classes.grid}>
                <div className={classes.inputGroup}>
                  <label>Employer Name</label>
                  <input type="text" name="employer_name" value={formData.employer_name} onChange={handleChange} />
                </div>
                <div className={classes.inputGroup}>
                  <label>Staff ID</label>
                  <input type="text" name="staff_id" value={formData.staff_id} onChange={handleChange} />
                </div>
                <div className={classes.inputGroup}>
                  <label>Department</label>
                  <input type="text" name="department" value={formData.department} onChange={handleChange} />
                </div>
              </div>
              <div className={classes.grid}>
                <div className={classes.inputGroup}>
                  <label>Monthly Salary</label>
                  <input type="number" name="monthly_salary" value={formData.monthly_salary} onChange={handleChange} />
                </div>
              </div>

              {/* NEXT OF KIN */}
              <h4 className={classes.sectionTitle}>Next of Kin</h4>
              <div className={classes.grid}>
                <div className={classes.inputGroup}>
                  <label>Full Name</label>
                  <input type="text" name="next_of_kin_name" value={formData.next_of_kin_name} onChange={handleChange} />
                </div>
                <div className={classes.inputGroup}>
                  <label>Relationship</label>
                  <input type="text" name="next_of_kin_relationship" value={formData.next_of_kin_relationship} onChange={handleChange} />
                </div>
                <div className={classes.inputGroup}>
                  <label>Phone Number</label>
                  <input type="text" name="next_of_kin_phone" value={formData.next_of_kin_phone} onChange={handleChange} />
                </div>
              </div>
              <div className={classes.inputGroup}>
                <label>Address</label>
                <textarea rows="3" name="next_of_kin_address" value={formData.next_of_kin_address} onChange={handleChange}></textarea>
              </div>

              {/* GUARANTOR INFORMATION */}
              <h4 className={classes.sectionTitle}>Guarantor Information</h4>
              <div className={classes.grid}>
                <div className={classes.inputGroup}>
                  <label>Guarantor Name</label>
                  <input type="text" name="guarantor_name" value={formData.guarantor_name} onChange={handleChange} />
                </div>
                <div className={classes.inputGroup}>
                  <label>Phone Number</label>
                  <input type="text" name="guarantor_phone" value={formData.guarantor_phone} onChange={handleChange} />
                </div>
                <div className={classes.inputGroup}>
                  <label>Membership No</label>
                  <input type="text" name="membership_no" value={formData.membership_no} onChange={handleChange} />
                </div>
              </div>

              {/* SAVINGS CONFIGURATION */}
              {/* <h4 className={classes.sectionTitle}>Savings Configuration</h4>
            <div className={classes.grid}>
              <div className={classes.inputGroup}>
                <label>Monthly Contribution</label>
                <input type="number" name="monthly_contribution" value={formData.monthly_contribution} onChange={handleChange} />
              </div>
              <div className={classes.inputGroup}>
                <label>Savings Type </label>
                <select name="savings_type" value={formData.savings_type} onChange={handleChange}>
                  <option value="">Select Type</option>
                  {roles?.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.product_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className={classes.inputGroup}>
                <label>Registration Date</label>
                <input type="date" name="registration_date" value={formData.registration_date} onChange={handleChange} />
              </div>
            </div> */}

              <div className={classes.footer}>
                <div className={classes.actions}>
                  <button type="button" className={`${classes.btn} ${classes.btnGhost}`} onClick={handleReset}>
                    Reset
                  </button>
                  <button type="submit" className={`${classes.btn} ${classes.btnPrimary}`} disabled={saving}>
                    {saving ? "Saving..." : isEdit ? "Update Member" : "Save Member"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddMember;